import { questionType } from "../types";

export const shouldQuestionRender = (
	question: questionType,
	fields: {
		[key: string]: string;
	}
) => {
	const { displayCriteria } = question;
	if (!displayCriteria) return true;
	const { questionName, questionValue } = displayCriteria;
	return fields[questionName] === questionValue;
};

export const filterQuestionBySection = (
	questions: questionType[],
	section: string
) => {
	return questions.filter((questionData) => questionData.section === section);
};

export const orderQuestionsByItemOrder = (questions: questionType[]) => {
	return questions.sort((a, b) => a.itemOrder - b.itemOrder);
};

export const getUniqueOrderedSections = (
	questions: questionType[],
) => {
	if(!questions)return;
	const sectionOrders = [
		...new Map(questions.map((item) => [item["section"], item])).values(),
	];
	return sectionOrders.sort((a, b) => a.sectionOrder - b.sectionOrder).map(item => item.section);
};
